import { render, staticRenderFns } from "./paySearchOri.vue?vue&type=template&id=5fa37f41&scoped=true"
import script from "./paySearchOri.vue?vue&type=script&lang=js"
export * from "./paySearchOri.vue?vue&type=script&lang=js"
import style0 from "./paySearchOri.vue?vue&type=style&index=0&id=5fa37f41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa37f41",
  null
  
)

export default component.exports